<template>
    <div>
        <b-row>
            <b-col>
                <h2>📈 Gestión de Metas</h2>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div>
                    <p>
                        Asigne metas claras y alcanzables a sus colaboradores
                        para medir su rendimiento y mejorar la productividad de
                        su equipo.
                    </p>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" md="6">
                <b-form-group label="Seleccionar Grupo:">
                    <b-form-select
                        v-model="type"
                        :options="indicatorTypes"
                        value-field="id"
                        text-field="name"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >-- Seleccione un grupo --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group label="Seleccionar Usuario:">
                    <app-autocomplete
                        v-model="selectedUser"
                        :items="users"
                        value-field="id"
                        text-field="name"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >-- Seleccione un usuario
                                --</b-form-select-option
                            >
                        </template>
                    </app-autocomplete>
                </b-form-group>
            </b-col>
        </b-row>

        <div v-if="selectedUser">
            <b-row>
                <b-col>
                    <b-alert show variant="info">
                        <p>
                            <b>Nota:</b> El valor -1 en las metas indica que
                            esta se calculará de acuerdo a las asignaciones
                            configuradas en el sistema, por ejemplo para los
                            ejecutivos se calcula con el número de clientes
                            asignados. Si se especifica un valor numérico, este
                            será la meta a alcanzar.
                        </p>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <h4 class="mt-4">
                        Indicadores para {{ selectedUserName }}
                    </h4>
                    <b-table striped hover :items="indicators" :fields="fields">
                        <template #cell(assigned)="{ item }">
                            <b-form-input v-model="item.forecast" />
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </div>

        <b-row v-if="selectedUser">
            <b-col>
                <b-button variant="primary" @click="saveAssignments"
                    >Guardar Asignaciones</b-button
                >
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        //
    },
    data: () => ({
        selectedUser: null,
        type: null,
        users: [],
        indicatorTypes: [],
        indicators: [],
        userIndicators: [],
        fields: [
            { key: 'name', label: 'Nombre' },
            { key: 'description', label: 'Descripción' },
            { key: 'assigned', label: 'Asignar' },
        ],
    }),
    watch: {
        type(newVal) {
            if (!newVal) return
            this.loadIndicators()
            if (this.selectedUser) {
                this.loadUserIndicators()
            }
        },
        selectedUser(newVal) {
            if (!newVal) return
            this.userIndicators = []
            this.loadUserIndicators()
        },
    },
    methods: {
        toggleIndicator(indicator) {
            // Aquí puedes implementar la lógica para actualizar el estado del indicador
            console.log(
                `Indicador ${indicator.name} ${
                    indicator.assigned ? 'asignado' : 'desasignado'
                } para ${this.selectedUserName}`
            )
        },
        async saveAssignments() {
            try {
                const { data } = await this.$repo.post(
                    `users/${this.selectedUser.id}/indicators`,
                    {
                        indicators: this.indicators.map((i) => ({
                            forecast_goal_id: i.id,
                            value: i.forecast,
                        })),
                    }
                )

                const { error } = data
                if (error) {
                    return toastr.error('Error guardando las asignaciones')
                }
                toastr.success('Asignaciones guardadas correctamente')
            } catch (error) {
                toastr.error('Error guardando las asignaciones')
                console.error('Error guardando las asignaciones:', error)
            }
        },
        async loadIndicators() {
            try {
                if (!this.type) return
                const { data } = await this.$repo.get(
                    'forecasting/indicators',
                    {
                        type: this.type,
                    }
                )
                this.indicators = data
            } catch (error) {
                toastr.error('Error cargando los indicadores')
                console.error('Error cargando los indicadores:', error)
            }
        },
        async loadUserIndicators() {
            try {
                const { data } = await this.$repo.get(
                    `users/${this.selectedUser.id}/indicators`
                )
                this.userIndicators = data

                this.indicators = this.indicators.map((indicator) => {
                    const userIndicator = this.userIndicators.find(
                        (ui) => ui.forecast_goal_id == indicator.id
                    )
                    return {
                        ...indicator,
                        assigned: !!userIndicator,
                        forecast: userIndicator ? userIndicator.value : '',
                    }
                })
            } catch (error) {
                toastr.error('Error cargando los indicadores del usuario')
            }
        },
        async loadUsers() {
            try {
                const { data } = await this.$repo.get('forecasting/users')
                this.users = data
            } catch (error) {
                toastr.error('Error cargando los usuarios')
            }
        },
        async loadIndicatorTypes() {
            try {
                const { data } = await this.$repo.get(
                    'forecasting/indicator-types'
                )
                this.indicatorTypes = data.map(({ type }) => ({
                    id: type,
                    name: type.charAt(0).toUpperCase() + type.slice(1),
                }))
            } catch (error) {
                toastr.error('Error cargando los tipos de indicadores')
            }
        },
    },
    computed: {
        selectedUserName() {
            const user = this.users.find((u) => u.id === this.selectedUser)
            return user ? user.name : ''
        },
    },
    mounted() {
        this.loadIndicatorTypes()
        this.loadUsers()
    },
}
</script>
